import { alpha } from '@mui/material/styles'
import {
  Construction as ConstructionIcon,
  PrecisionManufacturing as PrecisionManufacturingIcon,
  HourglassEmpty as HourglassEmptyIcon,
  ErrorOutline as ErrorOutlineIcon,
  PowerSettingsNew as PowerSettingsNewIcon,
  HelpOutline as HelpOutlineIcon,
  StopCircle as StopCircleIcon,
  Inventory2Outlined as Inventory2OutlinedIcon,
  WorkOutline as WorkOutlineIcon,
  PersonOutline as PersonOutlineIcon,
  Image as ImageIcon
} from '@mui/icons-material'

import { statusIcons, machineIcons } from '../../../../../../images'

/**
 * Mapping of device types to image icons
 */
export const DEVICE_TYPE_ICONS = {
  STORAGE: machineIcons.storage,
  CMM: machineIcons.cmm,
  EDM: machineIcons.edm,
  MACHINING_CENTER: machineIcons.cnc,
  HANDLER: machineIcons.handler,
  POLISHING_CENTER: machineIcons.polish,
  OPERATOR: machineIcons.operator,
  IDENTIFICATION: machineIcons.camera,
  MARKING: machineIcons.marking,
  CLEANING_CENTER: machineIcons.cleaning,
  TREATMENT_CENTER: machineIcons.treatment,
  DEBURRING_CENTER: machineIcons.deburring,
  PRINTER_3D: machineIcons.printer3d
}

/**
 * Mapping of operation modes to status icons
 */
export const MODE_ICONS = {
  AUTO: statusIcons.auto,
  MANUAL: statusIcons.manual,
  OFFLINE: statusIcons.offline,
  NON_OPERATIVE: statusIcons.off
}

/**
 * Definition of device statuses with their styles and icons
 * @param {object} theme - MUI theme
 * @param {function} t_ - Translation function
 */
export const getStatusConfig = (status, theme, t_) => {
  const s = status?.toUpperCase() || 'UNKNOWN'

  // Base configuration
  const baseConfigs = {
    MACHINING: {
      bg: alpha(theme.palette.success.main, 0.15),
      text: theme.palette.success.main,
      icon: PrecisionManufacturingIcon,
      label: t_('RUNNING')
    },
    WAITING: {
      bg: alpha(theme.palette.warning.main, 0.15),
      text: theme.palette.warning.main,
      icon: HourglassEmptyIcon,
      label: t_('WAITING')
    },
    ERROR: {
      bg: alpha(theme.palette.error.main, 0.15),
      text: theme.palette.error.main,
      icon: ErrorOutlineIcon,
      label: t_('ERROR')
    },
    STOP: {
      bg: alpha(theme.palette.error.main, 0.15),
      text: theme.palette.error.main,
      icon: StopCircleIcon,
      label: t_('STOP')
    },
    OFF: {
      bg: alpha(theme.palette.action.disabledBackground, 0.15),
      text: theme.palette.text.disabled,
      icon: PowerSettingsNewIcon,
      label: t_('OFF')
    },
    UNKNOWN: {
      bg: alpha(theme.palette.info.main, 0.15),
      text: theme.palette.info.main,
      icon: HelpOutlineIcon,
      label: t_('UNKNOWN')
    }
  }

  // Mapping of aliases to base configurations
  const aliasMap = {
    RUNNING: 'MACHINING',
    ON: 'MACHINING',
    WORKING: 'MACHINING',
    IDLE: 'WAITING',
    ALARM: 'ERROR',
    NON_OPERATIVE: 'ERROR',
    STOPPED: 'STOP',
    OFF: 'OFF'
  }

  // Resolve configuration
  const configKey = aliasMap[s] || s
  return baseConfigs[configKey] || baseConfigs.UNKNOWN
}

/**
 * Icons for data rows
 */
export const DATA_ICONS = {
  active: Inventory2OutlinedIcon,
  part: WorkOutlineIcon,
  operator: PersonOutlineIcon,
  default: ImageIcon,
  construction: ConstructionIcon
}
